
























































































































































































































































































































































import { ElForm } from "element-ui/types/form";
import { Component, Vue } from "vue-property-decorator";
import Maps from "./map.vue";
import area from "@/utils/area";
import {
  addUpdateTenant,
  getNodeData,
  uploadImg,
} from "@/serve/medicalAppointment/institutionManage";
import { natureOptions, gradeOptions, formSections } from "./options";

const defaultDetail = {
  tenantDetailLat: "",
  tenantDetailLong: "",
  tenantDetailTelephone: "",
  tenantDetailJobTime: "",
  tenantDetailInfo: "",
  tenantDetailImage: "",
  tenantDetailSort: "",
  advertisementDescription: "",
  advertisementImage: "",
  advertisementLink: "",
  faceVerifyMode: "",
  fileType: "",
  groupMode: "",
  quotaMode: "0",
  groupItemMode: "1",
  isMultiple: "1",
};

const addressProps = [
  "province",
  "city",
  "district",
  "address",
  "jkglTenantDetail.tenantDetailLat",
  "jkglTenantDetail.tenantDetailLong",
  "jkglTenantDetail.tenantDetailJobTime",
  "jkglTenantDetail.tenantDetailTelephone",
];
const businessProps = [
  "optional",
  "onlinePayment",
  "jkglTenantDetail.faceVerifyMode",
  "jkglTenantDetail.fileType",
  "jkglTenantDetail.groupMode",
  "jkglTenantDetail.quotaMode",
  "jkglTenantDetail.groupItemMode",
];

@Component({
  name: "AddAndEdit",
  components: { Maps },
})
export default class AddAndEdit extends Vue {
  public natureOptions = natureOptions;
  public gradeOptions = gradeOptions;
  public formSections = formSections;
  public activeSection = "basic";
  public formLabelWidth = "160px";
  public area = area;
  public formData = {
    name: "",
    code: "",
    img: "",
    imgAd: "",
    status: "",
    nature: "",
    grade: "",
    province: "",
    city: "",
    district: "",
    address: "",
    optional: "",
    onlinePayment: "",
    jkglTenantDetail: { ...defaultDetail },
  };
  public rules = {
    name: [{ required: true, message: "请输入机构名称", trigger: "blur" }],
    code: [{ required: true, message: "请输入机构编号", trigger: "blur" }],
    img: [{ required: true, message: "请选择封面", trigger: "blur" }],
    status: [{ required: true, message: "请选择机构状态", trigger: "blur" }],
    nature: [{ required: true, message: "请选择机构性质", trigger: "blur" }],
    grade: [{ required: true, message: "请选择机构等级", trigger: "blur" }],
    province: [{ required: true, message: "请选择省份", trigger: "blur" }],
    city: [{ required: true, message: "请选择城市", trigger: "blur" }],
    district: [{ required: true, message: "请选择区/街道", trigger: "blur" }],
    address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
    "jkglTenantDetail.tenantDetailLat": [
      { required: true, message: "请输入机构经度", trigger: "blur" },
    ],
    "jkglTenantDetail.tenantDetailLong": [
      { required: true, message: "请输入机构维度", trigger: "blur" },
    ],
    "jkglTenantDetail.tenantDetailJobTime": [
      {
        required: true,
        message: "输入时间范围例如:(周一至周五,8点至20点)",
        trigger: "blur",
      },
    ],
    "jkglTenantDetail.tenantDetailTelephone": [
      {
        required: true,
        validator: this.validatePhone,
        trigger: "blur",
      },
    ],
    optional: [
      { required: true, message: "请选择是否允许项目自选", trigger: "blur" },
    ],
    onlinePayment: [
      { required: true, message: "请选择支付模式", trigger: "blur" },
    ],
    "jkglTenantDetail.faceVerifyMode": [
      { required: true, message: "请选择人脸核身模式", trigger: "blur" },
    ],
    "jkglTenantDetail.fileType": [
      { required: true, message: "请选择报告类型", trigger: "blur" },
    ],
    "jkglTenantDetail.groupMode": [
      { required: true, message: "请选择团检模式", trigger: "blur" },
    ],
    "jkglTenantDetail.quotaMode": [
      { required: true, message: "请选择团检限额模式", trigger: "blur" },
    ],
    "jkglTenantDetail.groupItemMode": [
      { required: true, message: "请选择团检套餐项目模式", trigger: "blur" },
    ],
    "jkglTenantDetail.tenantDetailInfo": [
      { required: true, message: "请填写机构介绍", trigger: "blur" },
    ],
  };

  get isXxMode() {
    return String(this.formData.jkglTenantDetail.groupMode) === "3";
  }
  get showQuotaMode() {
    const mode = String(this.formData.jkglTenantDetail.groupMode);
    return mode === "2" || mode === "3";
  }

  public goBack() {
    this.$emit("back");
  }

  public validatePhone(
    _rule: any,
    value: string | any[],
    callback: (arg0?: Error | undefined) => void
  ) {
    if (value === "") {
      callback(new Error("请输入联系方式!"));
      return;
    }
    callback();
  }

  public async getTenant(row: { id: string }) {
    const res = await getNodeData(row.id);
    if (res.success) {
      this.formData = {
        ...this.formData,
        ...res.data,
        jkglTenantDetail: {
          ...defaultDetail,
          ...(res.data.jkglTenantDetail || {}),
        },
      };
    }
    this.activeSection = "basic";
  }

  public async uploadImage(res: { file: File }, type: "cover" | "ad") {
    const imgs = new FormData();
    imgs.append("file", res.file);
    const file = await uploadImg(imgs);
    const url = file.data;
    if (type === "cover") {
      this.formData.img = url;
      this.formData.jkglTenantDetail.tenantDetailImage = url;
    } else {
      this.formData.imgAd = url;
      this.formData.jkglTenantDetail.advertisementImage = url;
    }
  }

  public beforeAvatarUpload(file: { type: string; size: number }) {
    const isPG = file.type === "image/jpeg" || file.type === "image/png";
    const isLt2M = file.size / 1024 / 1024 < 1;
    if (!isPG) {
      this.$message.error("上传头像图片只能是 JPG/PNG格式!");
    }
    if (!isLt2M) {
      this.$message.error("上传头像图片大小不能超过 2MB!");
    }
    return isPG && isLt2M;
  }

  public selectProvinc() {
    this.formData.city = "";
    this.formData.district = "";
  }

  public confirm(lnt: any, lat: any, address: any) {
    this.$set(this.formData.jkglTenantDetail, "tenantDetailLong", lnt);
    this.$set(this.formData.jkglTenantDetail, "tenantDetailLat", lat);
    this.$set(this.formData, "address", address);
  }

  public jumpToError(prop: string) {
    if (addressProps.indexOf(prop) !== -1) {
      this.activeSection = "address";
    } else if (businessProps.indexOf(prop) !== -1) {
      this.activeSection = "business";
    } else {
      this.activeSection = "basic";
    }
  }

  public handlerSubmit() {
    (this.$refs.formData as ElForm).validate(async (valid, invalidFields) => {
      if (!valid) {
        const first = invalidFields && Object.keys(invalidFields)[0];
        if (first) {
          this.jumpToError(first);
        }
        return false;
      }
      this.$set(
        this.formData.jkglTenantDetail,
        "tenantDetailTelephone",
        String(this.formData.jkglTenantDetail.tenantDetailTelephone)
      );
      const res = await addUpdateTenant(this.formData);
      if (res.success) {
        this.$emit("back", true);
        this.$message({
          message: "保存成功",
          type: "success",
        });
      }
    });
  }
}
